import React from 'react'

export const Footer = () => {
  return (
    <footer>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <a className="nav-link link" href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=new" target="_blank">Contact Us</a>
            </li>
            <li className="nav-item">
              <a className="nav-link link" href="https://github.com/AshmitM14" target="_blank">GitHub</a>
            </li>
            <li className="nav-item">
              <a className="nav-link link" href="https://discord.com/users/id/910010366870822922" target="_blank">Discord</a>
            </li>
            
          </ul>
        </div>
        </nav>
    </footer>
  )
}











